var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useContext } from 'react';
import { CardActions as MuiCardActions, } from '@mui/material';
import { CardContext } from './utils';
export var CardActions = function (_a) {
    var _b = _a.row, row = _b === void 0 ? false : _b, children = _a.children, sx = _a.sx, props = __rest(_a, ["row", "children", "sx"]);
    var size = useContext(CardContext);
    return (React.createElement(MuiCardActions, __assign({ sx: __assign(__assign(__assign({}, (row && { flexDirection: 'row' })), (size === 'medium'
            ? { mt: '24px', px: '24px' }
            : { mt: '16px', px: '16px' })), sx) }, props), children));
};
//# sourceMappingURL=CardActions.js.map